module.exports = __webpack_public_path__ + "static/media/hizal-01.156e6d3f.jpg";